export const linkify = (text: string) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  return text.split(urlRegex).map((part, index) => {
    if (part.match(urlRegex)) {
      return { type: 'link', value: part, key: index };
    }
    return { type: 'text', value: part, key: index };
  });
};
